import type { KartSetupSummary } from '@kangaroo/shared';

function formatTrackWidth(value: number | null | undefined) {
  return value == null ? 'N/A' : `${value} mm`;
}

function formatGearRatio(driver: number | null | undefined, axle: number | null | undefined) {
  if (driver == null || axle == null) return 'N/A';
  return `${driver} / ${axle}`;
}

function formatTirePressure(value: number | null | undefined) {
  return value == null ? 'N/A' : `${value} psi`;
}

function formatWeight(value: number | null | undefined) {
  return value == null ? 'N/A' : `${value} kg`;
}

export function setupSnapshotRows(setup: KartSetupSummary) {
  return [
    ['Front track', formatTrackWidth(setup.frontTrackWidthMm)],
    ['Rear track', formatTrackWidth(setup.rearTrackWidthMm)],
    ['Seat', setup.seatPosition ?? 'N/A'],
    ['Gearing', formatGearRatio(setup.gearRatioDriver, setup.gearRatioAxle)],
    ['Front PSI', formatTirePressure(setup.frontTirePressurePsi)],
    ['Rear PSI', formatTirePressure(setup.rearTirePressurePsi)],
    ['Weight', formatWeight(setup.totalWeightKg)],
  ] as const;
}

export function changedSetupLabels(current: KartSetupSummary, previous?: KartSetupSummary) {
  if (!previous) {
    return ['Initial snapshot'];
  }

  const changes = [
    ['Front track', current.frontTrackWidthMm, previous.frontTrackWidthMm],
    ['Rear track', current.rearTrackWidthMm, previous.rearTrackWidthMm],
    ['Seat', current.seatPosition, previous.seatPosition],
    ['Driver gear', current.gearRatioDriver, previous.gearRatioDriver],
    ['Axle gear', current.gearRatioAxle, previous.gearRatioAxle],
    ['Front PSI', current.frontTirePressurePsi, previous.frontTirePressurePsi],
    ['Rear PSI', current.rearTirePressurePsi, previous.rearTirePressurePsi],
    ['Weight', current.totalWeightKg, previous.totalWeightKg],
  ].filter(([, nextValue, previousValue]) => nextValue !== previousValue);

  return changes.length > 0 ? changes.map(([label]) => String(label)) : ['Setup context updated'];
}
